import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class DashboardService {

    constructor(private http: HttpClient) { }

    public fetchBusinessGeneral(): Observable<any> {
        const url = `${environment.API_ENDPOINT}/dashboard/businessGeneral`;
        return this.http.get(url, {});
    }

    public fetchPropertyGeneral(): Observable<any> {
        const url = `${environment.API_ENDPOINT}/dashboard/propertyGeneral`;
        return this.http.get(url, {});
    }
}
